import React from "react";
import PageLayout from "../../../components/Layout/PageLayout";
import AccessControlsAuditTrails from "./misc/AccessControlsAuditTrails";

const AccessControls: React.FC = () => {
  return (
    <PageLayout>
      <AccessControlsAuditTrails />
    </PageLayout>
  );
};

export default AccessControls;
